
import { defineComponent, PropType } from 'vue'

type CHECKBOX_SIZES = 'small' | 'base' | 'large'

export default defineComponent({
  name: 'ZCheckbox',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    label: {
      default: '',
      type: String
    },
    name: {
      default: '',
      type: String
    },
    checkedValue: {
      default: '',
      type: String
    },
    trueValue: {
      default: true,
      type: Boolean
    },
    falseValue: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    readOnly: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: false,
      type: [Boolean, String, Array]
    },
    size: {
      default: 'base',
      type: String as PropType<CHECKBOX_SIZES> as PropType<'small' | 'base' | 'large'>,
      validator: (value: string) => {
        return ['small', 'base', 'large'].includes(value)
      }
    }
  },
  computed: {
    isChecked(): boolean {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.checkedValue)
      }
      return this.modelValue === this.trueValue
    },
    checkBoxSize(): string {
      const sizes: Record<CHECKBOX_SIZES, string> = {
        small: 'h-4 w-4',
        base: 'h-5 w-5 font-medium',
        large: 'h-6 w-6 font-semibold'
      }
      return sizes[this.size] ?? 'h-5 w-5'
    },
    fontSize(): string {
      const sizes: Record<CHECKBOX_SIZES, string> = {
        small: 'text-sm',
        base: 'text-base ml-1',
        large: 'text-lg ml-2'
      }
      return sizes[this.size] ?? 'text-base ml-2'
    }
  },
  methods: {
    updateInput(event: Event) {
      const isChecked = (event.target as HTMLInputElement as HTMLInputElement).checked

      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue]

        if (isChecked) {
          newValue.push(this.checkedValue)
        } else {
          newValue.splice(newValue.indexOf(this.checkedValue), 1)
        }
        this.$emit('change', newValue, event)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue, event)
      }
    }
  }
})
